import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import { Link } from 'react-router-dom';
import { Actions } from '../../flux';
import { images, texts, relacionamentos } from '../../settings';
import { DelayLink, SliderText } from '../../components';

import './Organograma.scss';

class Organograma extends Component {
  constructor(props) {
    super(props);

    this.contentText = React.createRef();
  }

  scrollTop = () => {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  };

  componentDidMount = () => {
    Actions.headerIntern();
    this.scrollTop();
  };

  render = () => {
    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>Nosso Ano - {texts.title}</title>
        </Helmet>

        <div className="organograma-home page-gradient page-gradient--green bg-gray" ref="organograma-home">
          <section className="organograma-home-area page-gradient__header">
            <div className="container">
              <div className="row">
                <div className="col-5">
                  <Fade bottom>
                    <div className="page-header">
                      <h1 className="page-header__title">Organograma</h1>
                      <p className="page-header__description gri_text">
                        Estamos divididos em quatro superintendências: uma cuida do Selic e as outras três refletem os
                        compromissos que assumimos com o mercado – Educação e Informações Técnicas (educar e informar);
                        Representação Institucional (representar); e Supervisão de Mercados (autorregular).
                        <br />
                        <br />
                        Além disso, temos cinco gerências que respondem diretamente para a superintendência-geral:
                        Assessoria Jurídica; Recursos Humanos; Comunicação e Marketing; Controladoria e Administração; e
                        Tecnologia da Informação.
                      </p>
                    </div>
                  </Fade>
                </div>

                <div className="col-7 col-image">
                  <img src={images.organograma.pessoa_topo} className="pessoa" />
                  <img src={images.organograma.quadro_topo} className="quadro" />
                </div>
              </div>
            </div>
          </section>

          <section className="organograma-body">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="governanca-body__content">
                    <Fade bottom>
                      <div className="shadowed_header">
                        <h2 className="center-title">
                          Confira a estrutura da associação e os líderes de cada uma das grandes áreas da equipe
                          interna:
                        </h2>
                      </div>
                    </Fade>
                  </div>
                </div>

                <div className="col-12 legenda">
                  <div>
                    <span className="blue"></span> Superintendência-geral
                  </div>
                  <div>
                    <span className="green"></span> Superintendência
                  </div>
                  <div>
                    <span className="yellow"></span> Gerência
                  </div>
                </div>

                <div className="col-12 organograma-fluxo">
                  <div className="fluxo-linha-corpo linha-1">
                    {/* <div className="fluxo-linha-topo"> */}
                    <div className="fluxo-item item-blue">
                      <h4>Superintendência-geral</h4>
                      <p>Zeca Doherty</p>
                    </div>
                  </div>
                  <div className="fluxo-linha-corpo linha-2">
                    <div className="fluxo-item item-green">
                      <h4>Recursos Humanos</h4>
                      <p>Eliana Marino</p>
                    </div>
                    <div className="fluxo-item item-green">
                      <h4>Comunicação e Marketing</h4>
                      <p>Marcelo Billi</p>
                    </div>
                  </div>
                  <div className="fluxo-linha-corpo linha-3">
                    <div className="fluxo-item item-green">
                      <h4>Assessoria Jurídica</h4>
                      <p>Soraya Alves</p>
                    </div>
                    <div className="fluxo-item item-green">
                      <h4>
                        {' '}
                        Controladoria <span>e Administração</span>
                      </h4>
                      <p>Thiago Baptista</p>
                    </div>
                  </div>
                  <div className="fluxo-linha-corpo linha-4">
                    <div className="fluxo-item item-green">
                      <h4>
                        {' '}
                        Tecnologia <span>da Informação</span>
                      </h4>
                      <p>Lina Yajima</p>
                    </div>
                  </div>
                  <div className="fluxo-linha-corpo linha-5">
                    <div className="fluxo-coluna coluna-1">
                      <div className="fluxo-item item-yellow">
                        <h4>Representação Institucional</h4>
                        <p>Patricia Herculano</p>
                      </div>
                      <div className="fluxo-item item-green">
                        <h4>
                          Fundos de Investimento <span>e Serviços Qualificados</span>
                        </h4>
                        <p>Tatiana Itikawa</p>
                      </div>
                      <div className="fluxo-item item-green">
                        <h4>Finanças Corporativas e Fundos Estruturados</h4>
                        <p>Erika Lacreta</p>
                      </div>
                      <div className="fluxo-item item-green">
                        <h4>
                          Distribuição de Produtos <span>de Investimento</span>
                        </h4>
                        <p>Luiz Henrique Carvalho</p>
                      </div>
                      <div className="fluxo-item item-green">
                        <h4>Operações de Tesouraria</h4>
                        <p>Anna Jimenez</p>
                      </div>
                    </div>
                    <div className="fluxo-coluna coluna-2">
                      <div className="fluxo-item item-yellow">
                        <h4>
                          Educação e <span>Informações Técnicas</span>
                        </h4>
                        <p>Ana Leoni</p>
                      </div>
                      <div className="fluxo-item item-green">
                        <h4>Certificação e Educação Continuada</h4>
                        <p>Daniel Pfannemüller</p>
                      </div>
                      <div className="fluxo-item item-green">
                        <h4>Informações Técnicas</h4>
                        <p>Rodrigo Guerrero</p>
                      </div>
                      <div className="fluxo-item item-green">
                        <h4>Preços e Índices</h4>
                        <p>Hilton Notini</p>
                      </div>
                    </div>
                    <div className="fluxo-coluna coluna-3">
                      <div className="fluxo-item item-yellow">
                        <h4>Supervisão de Mercados</h4>
                        <p>Guilherme Benaderet</p>
                      </div>
                      <div className="fluxo-item item-green">
                        <h4>Distribuição, Ofertas Públicas, Negociação e Certificação</h4>
                        <p>Priscilla Sorrentino</p>
                      </div>
                      <div className="fluxo-item item-green">
                        <h4>Fundos de Investimento, Carteiras Administradas e Serviços Qualificados</h4>
                        <p>Soraia Barros</p>
                      </div>
                      <div className="fluxo-item item-green">
                        <h4>Operações</h4>
                        <p>Alessandro Rigon</p>
                      </div>
                    </div>
                    <div className="fluxo-coluna coluna-4">
                      <div className="fluxo-item item-yellow">
                        <h4>Selic</h4>
                        <p>Francisco Vidinha</p>
                      </div>
                      <div className="fluxo-item item-green">
                        <h4>Desenvolvimento</h4>
                        <p>Adaline Viana</p>
                      </div>
                      <div className="fluxo-item item-green">
                        <h4>Operações</h4>
                        <p> Renato Vieira</p>
                      </div>
                      <div className="fluxo-item item-green">
                        <h4>Suporte</h4>
                        <p>Rodolfo Dantas</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="organograma-footer-area governanca-footer">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade>
                    <div className="box-pill box-pill--green box-pill--center">
                      <div className="box-pill__content box-pill__content--full">
                        <div className="row">
                          <div className="col col-10 col--text">
                            <h4>Veja a mensagem do nosso superintendente-geral</h4>
                            <DelayLink
                              to="/mensagens/superintendencia"
                              className="button button--aylen button--white-to-green button--border-medium button--size-m button--round-l button--text-thick"
                            >
                              Saiba mais
                            </DelayLink>
                          </div>
                          <div className="col col-2 col--image">
                            <img
                              src={images.organograma.pessoa_destaque}
                              className="pessoa_destaque pessoa_destaque--1"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  };
}

export { Organograma };
